import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import {
  TabsContainerService,
  BaseTabsContainer,
  UserService,
  BaseDataService,
  ModalService,
  ModelDataService,
  ErrorHandlerService,
  NotificationService,
  QueryParameter,
  ConfirmationDialogButtons,
  TableContextMenuItem
} from 'yt-ng-framework';
import { DefaultListTabsComponent } from 'yt-ng-framework';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { EPrijemnicaView } from './eprijemnica-view';
import { EPrijemnicaService } from './eprijemnica-service';
import { EOtpremniceFilterComponent } from '../_filters/eotpremnice-filter.component';
import { EPrijemnicaTabUpdateComponent } from './eprijemnica-tab-update.component';
import { Attachment } from '../edokument/attachment';
import { EPrijemnica } from './eprijemnica';
import { Observable, Subject } from 'rxjs';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'yt-eprijemnica-tabs',
  templateUrl: './eprijemnica-tabs.component.html',
  styles: [
  ]
})
export class EPrijemnicaTabsComponent
  extends BaseTabsContainer<EPrijemnicaView>
 implements OnInit {
  @ViewChild("defaultList", { static: false })
  defaultList: DefaultListTabsComponent<EPrijemnicaView>;
  @ViewChild("filterFak", { static: false }) filterFak: EOtpremniceFilterComponent;
  @ViewChild('baseTabsUpdate', { static: false })
  eprijemnicaTabUpdateComponent: EPrijemnicaTabUpdateComponent;
  @Input() RefreshStatusClicked() {}
  osvezavanjeUToku=false;
  items: Attachment[] = [];
  loading: boolean = false;

  constructor(
    public tabsContainerService: TabsContainerService<EPrijemnicaView>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService,
    protected toastrService: NotificationService,
    protected modalService: ModalService,
    protected translateService: TranslateService,
    protected modelDataService: ModelDataService,
    protected errorService: ErrorHandlerService,
    protected eprijemnicaService: EPrijemnicaService,
  ) { 
      super(tabsContainerService, activatedRoute, userService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.eprijemnicaService.baseTabsComponent = this;

    console.log("defaultList:", this.defaultList);
    // Osnovna inicijalizacija: hvatanje promene taba (ako želiš logiku kasnije)
    this.tabsContainerService.ActiveTab.subscribe(tabID => {
      if (tabID === 'tbList') {
        console.log('[EPrijemnicaTabsComponent] Povratak na listu');
      } else if (tabID === 'tbUpdate') {
        console.log('[EPrijemnicaTabsComponent] Otvoren tab za izmenu');
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.defaultList.filterComponent = this.filterFak;
      this.filterFak.showStatusBox = true;
      this.filterFak.ApplyFilter();

        // if (this.defaultList.mainItems != null)
          // this.filterFak.RefreshStatusClick();
          this.filterFak.StatusRefreshTime=new Date();
          this.filterFak.loadingFilter = false;
          this.loading = false;
          this.filterFak.SetStatusDescription(this.modelData["MainList"]["FormControlDataName"] == 'eprijemnice/izeprijemnica');
          this.filterFak.collapsed1=true;
          this.filterFak.filterFormGroup.enable();
    }, 1000);
      const intervalCheck = setInterval(() => {
      if (this.defaultList.mainItems) {
        clearInterval(intervalCheck); // Prekini proveru kada se inicijalizuje
        const brojDanaZaProveru = 5;
        this.refreshStatus(brojDanaZaProveru);
      }
    }, 100); // Provera na svakih 100ms
  }

   async refreshStatus(oldToDays: number) {
    var nastalaJeGreska=false;
    let __this=this;
    var odDana = new Date();
    let doDana = new Date();
    let proveraIDs : boolean = false;

    const selectedState = this.defaultList.GetMainSelectionState();

    this.filterFak.filterFormGroup.disable();
    this.filterFak.StatusRefreshTime=new Date();
    this.filterFak.SetStatusDescription(this.modelData["MainList"]["FormControlDataName"] == 'eprijemnice/izeprijemnica');
    this.filterFak.loadingFilter = true;
    this.loading = true;

    odDana.setDate(odDana.getDate() - oldToDays);
    odDana = new Date(odDana.getFullYear(), odDana.getMonth(), odDana.getDate());

    if (this.defaultList.mainItems != null){
    // this.defaultList.mainItems.forEach(async function (value) {
    const itemsZaOsvezavanje = this.defaultList.mainItems.filter(value => {
      const d = value["Datum"];
      const jsDate = new Date(d["year"], d["month"] - 1, d["day"]); // i ovo je 00:00
      return jsDate >= odDana;   // ovde gledaš samo od tog datuma pa naviše
    });

    for (const value of itemsZaOsvezavanje) {
      // const jsDate = new Date(
      //   value["Datum"]["year"],
      //   value["Datum"]["month"] - 1,
      //   value["Datum"]["day"]
      // );
      // if (jsDate >= odDana)
      // {
        try {
          await __this.OsveziStatus(value["ID"], true);
          console.log("OsveziStatus");
        } 
        catch (error) {
          nastalaJeGreska=true;
        }
      // };
    };

    if (nastalaJeGreska)
      // console.log("GreĹˇka pri osveĹľavanju statusa..")
      this.translateService.get('EPRIJEMNICA.STATUS.NEMOZEDAOSVEZI')
      .subscribe(translate => {
        window.alert(translate);
      })

      if (__this.modelData["MainList"]["FormControlDataName"] == 'eprijemnice/uleprijemnica'){
        __this.GetNewReceiptAdviceDocuments(odDana, doDana)
        .subscribe((value)=>{
          proveraIDs = value;
          if(proveraIDs){
            __this.filterFak.StatusRefreshTime=new Date();
            __this.filterFak.loadingFilter = false;
            __this.loading = false;
            __this.filterFak.SetStatusDescription(false);
            __this.filterFak.collapsed1=true;
            __this.filterFak.filterFormGroup.enable();
            // __this.tabsContainerService.EmitItem(selectedItem);
            setTimeout(() => {
              __this.defaultList.RestoreMainSelection(selectedState.id, selectedState.index);

            }, 0);

          }
        })
      }
      else{
        __this.filterFak.loadingFilter = false;
        __this.loading = false;
        __this.filterFak.collapsed1=true;
        __this.filterFak.filterFormGroup.enable();
        setTimeout(() => {
          __this.defaultList.RestoreMainSelection(selectedState.id, selectedState.index);

        }, 0);
        // __this.tabsContainerService.EmitItem(selectedItem);

      }

    }
      
    
  }

 
  GetNewReceiptAdviceDocuments(odDana: Date, doDana : Date): Observable<boolean>{
      this.osvezavanjeUToku=true;
      var subject = new Subject<boolean>();
      let odDana1: NgbDate = new NgbDate(odDana.getFullYear(), odDana.getMonth() + 1, odDana.getDate());
      let doDana1: NgbDate = new NgbDate(doDana.getFullYear(), doDana.getMonth() + 1, doDana.getDate());
  
  
      this.baseDataService
        .Post("EPrijemnica", "GetUlaznePrijemnice", {'DateFrom' : odDana1, 'DateTo' : doDana1}, EPrijemnicaView)
        .subscribe((data: EPrijemnicaView[]) => {
            console.log("GetUlaznePrijemnice");
            let brojNovihUlaznih : Number = data.length;
            let brojNovihKomitenata: number = data.filter(item => item.NoviKomitent == true).length;
  
            if (data != null){
              // data.forEach(item => 
              //   this.tabsContainerService.EmitItem(item)
              // );    
               data.forEach(item => 
                this.defaultList.AddOrUpdateMainItemWithoutSelectionChange(item)
              );         
              this.osvezavanjeUToku=false;
            }   
            this.translateService.get(['EPRIJEMNICA.BROJNOVIHULAZNIH.TITLE', 'EPRIJEMNICA.BROJNOVIHKOMITENATA.TITLE']) 
            .subscribe(translate => {         
              this.toastrService.info(translate['EPRIJEMNICA.BROJNOVIHULAZNIH.TITLE'],
                brojNovihUlaznih.toString());
              if (brojNovihKomitenata>0)             
                this.modalService.ShowConfirmationDialog("Novi komitenti",translate['EPRIJEMNICA.BROJNOVIHKOMITENATA.TITLE']+": "+brojNovihKomitenata.toString(),"info", ConfirmationDialogButtons.Ok)
              subject.next(true);    
            })
        }
        , error => {
        this.filterFak.loadingFilter = false;
        this.loading = false;
        let _message;   
        if(error instanceof HttpErrorResponse){
          _message = this.errorService.getServerMessage(error);           
          _message = "FW.ERRORS." + _message;
          this.translateService.get(_message)
          .subscribe(translate => {
            this.modalService.ShowConfirmationDialog("Problemi kod preuzimanja ulaznih prijemnica", translate, "warning", ConfirmationDialogButtons.Ok);
          });
        }
    })
      return subject.asObservable();
    }
  
   

  PosaljiEPrijemnicu(id: number){
    let _id: Number = id;
    
        this.baseDataService
          .GetByID("EPrijemnica", id, EPrijemnica)
          .subscribe((item: EPrijemnica) => {
            let _masterDokumID: Number = item.MasterDokumID;
            let _statusID = item.StatusID;
            let _today: Date = new Date();
            let _datum: Date = new Date(
              item.Datum["year"],
              item.Datum["month"] - 1,
              item.Datum["day"]
            );
  
            if (
              new Date(_datum.toLocaleDateString()) <
              new Date(_today.toLocaleDateString())
            ) {
              this.translateService
                .get(["EDOKUMENT.DATE.DATECANNOTBEDIFFERENTFROMTODAYS"])
                .subscribe((translate) => {
                  this.toastrService.warning(
                    translate["EDOKUMENT.DATE.DATECANNOTBEDIFFERENTFROMTODAYS"]
                  );
                });
              return false;
            }
          
              var /** @type {?} */ parameters1 = [];
              var /** @type {?} */ parameter = new QueryParameter();
              parameter.Name = "statusID";
              parameter.Value = _statusID;
              parameters1.push(parameter);
  
              if (_statusID == null || _statusID == 18 || _statusID==0){
                let _modelData =
                        this.modelDataService.GetModelDataByPath("send-eotpremnica");
                        let idParameter = new QueryParameter("ePrijemnicaID", _id);
                        let masterIdParameter = new QueryParameter(
                          "masterDokumID",
                          _masterDokumID
                        );
                        
                        let formControlDataNameParameter = new QueryParameter("formControlDataName", this.modelData["MainList"]["FormControlDataName"]);


                        if (_modelData) {
                          this.modalService
                            .ShowModal(0, _modelData, null, true, [
                              idParameter,
                              masterIdParameter,
                              formControlDataNameParameter
                            ])
                            .result.then(
                              (item) => {
                                this.defaultList.mainItems.find(
                                  (x) => x.ID === id
                                ).OsvezivogStatusa = true;
                                this.OsveziStatus(id, false);
                              },
                              (reason) => {}
                            );
                        }
              }
  
              
            });
  }

  prevod;
  
  async OsveziStatus(id, silent){
    if (this.defaultList.mainItems.find((x) => x.ID === id).OsvezivogStatusa)
    {
      let idParameter = new QueryParameter("id",id);
      let vrsta = this.modelData["MainList"]["UserRightsModelName"];
      let vrstaParameter = new QueryParameter("vrsta", vrsta);
  
      // this.baseDataService 
      //     .Get("EPrijemnica","OsveziStatus",[idParameter, vrstaParameter], EPrijemnicaView)
      //     .subscribe((data: EPrijemnicaView[]) =>{
      //       if (data != null) this.tabsContainerService.EmitItem(data[0]);
      //     });
      
      const refreshedItem: any = await this.baseDataService 
        .Get("EPrijemnica","OsveziStatus",[idParameter, vrstaParameter], EPrijemnicaView)
        .toPromise();
        // this.tabsContainerService.EmitItem(refreshedItem[0]);
        if (refreshedItem && refreshedItem.length > 0) {
          if (silent) {
            this.defaultList.UpdateMainItemWithoutSelectionChange(refreshedItem[0]);
          } else {
            this.tabsContainerService.EmitItem(refreshedItem[0]);
          }
        }

    }else {
      if (!silent){
        this.translateService
        .get("EPRIJEMNICA.STATUS.NEMOZEDAOSVEZI")
        .subscribe((translate) => {
          this.prevod = translate
  
          this.modalService.ShowConfirmationDialog(
            "Obaveštenje",
            this.prevod,
            "alert",
            ConfirmationDialogButtons.Ok
          );
        });
      }
    }
  }

  getProvajderGenericName(id: number) {
      var parameters = [];
      var provajderId = new QueryParameter();
      provajderId.Name = "id";
      provajderId.Value = id;
      parameters.push(provajderId);
      return this.baseDataService.Get(
        "Provajder",
        "getGenericName",
        parameters,
        null
      );
    }

  applayFilter(data) {
    this.defaultList.LoadMainItems(true, data);
  }

  SelectItemFormatDetailClicked(item) {
  }

PrihvatiPrijemnicu(id){
  this.eprijemnicaService.PrihvatiPrijemnicuService(id);
}

OdbijPrijemnicu(id){
  this.eprijemnicaService.OdbijPrijemnicuService(id);
}

  ContextMenuClicked(contextMenuItem : TableContextMenuItem){
    // if (contextMenuItem.Action == "Ponovi") {
    //   let id: number = contextMenuItem.ID;
    //   this.Ponovi(id);
    // }
    if (contextMenuItem.Action == "PosaljiEPrijemnicu") {
      let id: number = contextMenuItem.ID;
      this.PosaljiEPrijemnicu(id);
    }
   
    if (contextMenuItem.Action == "OsveziStatus") {
      let id: number = contextMenuItem.ID;
      this.OsveziStatus(id, false);
    }
    if (contextMenuItem.Action == "PrihvatiPrijemnicu"){
      let id:number = contextMenuItem.ID;
      this.PrihvatiPrijemnicu(id);
    }
   if (contextMenuItem.Action == "OdbijPrijemnicu"){
      let id:number = contextMenuItem.ID;
      this.OdbijPrijemnicu(id);
    }
    
  }
}
